import React from 'react';
import c from 'classnames';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphUrgencySubparagraph = ({ entity, id, singleUrgency }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_plain_body', 0, 'value']);
  const variant = entity.getIn(['field_variant', 0, 'value']);
  const image = entity.getIn(['field_media_image', 0, 'styles', '1_1']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkUri = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  const ParagraphUrgencySubparagraphClasses = c('ParagraphUrgencySubparagraph', {
    'ParagraphUrgencySubparagraph--one': variant === 'one',
    'ParagraphUrgencySubparagraph--two': variant === 'two',
    'ParagraphUrgencySubparagraph--three': variant === 'three',
    'ParagraphUrgencySubparagraph--four': variant === 'four',
  });

  return (
    <div className={ParagraphUrgencySubparagraphClasses}>
      <div className="ParagraphUrgencySubparagraph__inner">
        <Image className={singleUrgency ? 'ParagraphUrgencySubparagraph__image' : 'ParagraphUrgencySubparagraph__image__multi'} src={image} alt="" />
        <div className="ParagraphUrgencySubparagraph__text__wrapper">
          <div className="ParagraphUrgencySubparagraph__title">{title}</div>
          <div className="ParagraphUrgencySubparagraph__body">{body}</div>
        </div>
      </div>

      {linkUri && linkTitle && (
        <CoreLink className="ParagraphUrgencySubparagraph__link icon-after icon-chevron-right" to={linkUri}>{linkTitle}</CoreLink>
      )}

    </div>
  );
};

export default ParagraphUrgencySubparagraph;
